import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import styles from "./home.module.css";
import { encrypt, dcrypt } from "../extra/encrypt_decrypt";
import { characters1, characters2 } from "../extra/chars";

const Home = () => {
  let db = window.data_base;
  const [input, setInput] = useState("");
  const [showAddPassword, setShowAddPassword] = useState("hide");
  const [showSelectOptions, setShowSelectOptions] = useState("hide");
  const [showsetPassword, setShowsetPassword] = useState("hide");
  const [valid, setValid] = useState(true);

  function generateString(length) {
    let result = "";
    const charactersLength = characters1.length;
    for (let i = 0; i < length; i++) {
      result += characters1.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    return result;
  }
  const onInputChange = (ev) => {
    setInput(ev.target.value);
    if (ev.target.value < 10000 && ev.target.value > 999) {
      setValid(false);
    } else {
      setValid(true);
    }
  };
  const checkPasskey = () => {
    if (db) {
      const tx = db.transaction("passkey", "readonly");
      const passKey = tx.objectStore("passkey");

      let countRequest = passKey.count();
      countRequest.onsuccess = function () {
        if (countRequest.result === 0) {
          setShowAddPassword("fullDisplay");
        } else {
          setShowAddPassword("hide");

          const localValue = dcrypt(
            localStorage.getItem("Safe-notes"),
            characters2
          );

          var request = passKey.openCursor();
          let storedValue = null;
          request.onsuccess = (e) => {
            var result = e.target.result;
            if (!!result === false) {
              return;
            }
            storedValue = dcrypt(result.value.text, characters1);

            if (storedValue.join("") === localValue.join("")) {
              setShowSelectOptions("");
              setShowsetPassword("hide");
            } else {
              setShowsetPassword("fullDisplay");
            }
          };
        }
      };
    }
  };

  useEffect(() => {
    const dbName = window.dbnewName;
    const dbVersion = window.dbVer;
    const request = indexedDB.open(dbName, dbVersion);
    request.onsuccess = (e) => {
      // eslint-disable-next-line
      db = e.target.result;
      checkPasskey();
    };
  }, []);
  return (
    <div>
      <Navbar active="1" />
      <div className={styles.container}>
        <div className={styles.box}>
          <h1>Safe Notes</h1>
          <p>
            Secure your thoughts, protect your privacy with encrypted notes app
          </p>
          <div className={showSelectOptions}>
            <div className={styles.boxContain}>
              <Link to="/notes">
                <span>Notes</span>
                <i className="fa-solid fa-feather-pointed"></i>
              </Link>
              <Link to="/checklist">
                <span>Links</span>
                <i className="fa-solid fa-link"></i>
              </Link>
              <Link to="/passwords">
                <span>Passwords</span> <i className="fa-solid fa-key"></i>
              </Link>
            </div>
            <div className={styles.boxContain}>
              <div></div>
              <div
                onClick={() => {
                  localStorage.setItem("Safe-notes", 0);
                  window.location.reload();
                }}
              >
                <span>Lock</span>
                <i className="fa-solid fa-shield-halved"></i>
              </div>
            </div>
          </div>
          <div className={showsetPassword}>
            <div className={styles.form}>
              <h2>Enter Passkey</h2>
              <input
                type="number"
                onChange={onInputChange}
                min="1000"
                max="9999"
                placeholder="4 digit passkey..."
              />
              <button
                disabled={valid}
                onClick={() => {
                  let olddata = encrypt(input, characters2);
                  localStorage.setItem("Safe-notes", olddata.join(""));
                  window.location.reload();
                }}
              >
                Next
              </button>
            </div>
          </div>
          <div className={showAddPassword}>
            <div className={styles.form}>
              <h2>Add Passkey</h2>
              <input
                type="number"
                onChange={onInputChange}
                min="1000"
                max="9999"
                placeholder="Enter passkey... (4 digit)"
              />
              <button
                disabled={valid}
                onClick={() => {
                  const tx = db.transaction("passkey", "readwrite");
                  const newValue = {
                    id: generateString(10),
                    text: encrypt(input, characters1).join(""),
                  };
                  localStorage.setItem(
                    "Safe-notes",
                    encrypt(input, characters2).join("")
                  );
                  const newPasskey = tx.objectStore("passkey");
                  newPasskey.add(newValue);
                  window.location.reload();
                }}
              >
                Next
              </button>
              <small>Add a 4 digit passkey to start.</small>
            </div>
          </div>
        </div>
        <div className={styles.box}>
          <img src="images/home.png" alt="Safe Notes" />
        </div>
      </div>
      <div className={styles.footer}>
        <p>
          <i className="fa-regular fa-copyright"></i> Safe Notes 2023{" "}
        </p>
        <p> Developed By Yash Kumar Saini | Version 2.2</p>
      </div>
    </div>
  );
};

export default Home;
